import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { catchError, exhaustMap, map } from "rxjs/operators";
import { AuthenticationService, PermissionsApi } from "src/app/generated/CrossPoint.XpacProxy.Server";
import { ApiPermissions } from "src/app/utils/interfaces/auth.interfaces";
import { errorEventAction } from "../actions/app.actions";
import { getAuthInfoXpacProxyFailedAction, getAuthInfoXpacProxySuccessAction, ProxyActionsTypes } from "../actions/xpacProxy.action";


@Injectable()
export class XpacProxyEffects {

  public getAuthInfoXpacProxyEffect$: Observable<Action> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(ProxyActionsTypes.GET_AUTH_INFO_XPACPROXY),
        exhaustMap(() => this.authenticationService.getPermissions()
          .pipe(
            map((permissions: PermissionsApi) => getAuthInfoXpacProxySuccessAction({ data: permissions.permissions })),
            catchError((error: HttpErrorResponse) => {
              return of(errorEventAction({ data: { error: error, translationkey: "StoreActionFailed.GetAuthInfoXpacProxyErrorHasOccurred" } }), getAuthInfoXpacProxyFailedAction())
            })
          )
        )
      )
  );

  constructor(
    private actions$: Actions,   
    private authenticationService: AuthenticationService,
  ) { }
}
